import React from "react";
import cx from "classnames";

import styles from "./AvailableRewardCount.module.scss";

const AvailableRewardCount = ({
  availablePoints,
  className,
  rewardPointCost
}) => {
  const rewardCount = Math.floor(availablePoints / rewardPointCost);

  if (!rewardCount) {
    return null;
  }

  return (
    <div className={cx(styles.container, className)}>
      <p className={styles.count}>×{rewardCount}</p>
    </div>
  );
};

export default AvailableRewardCount;
